import createHttp from '@dmm/create-http';
import { createServiceDiscoveryClient } from '@dmm/create-http';
import { getConfig } from '../config/portal';
import { get } from 'lodash';
import * as utils from '../store/utils';

const MAX_HTTP_RETRY = 4;
const HEADER_PASSTHRU_LIST = ['x-forwarded-for'];

//Passthru some of the request headers downstream
const _headerPassthru = (http, headers = {}) => Object.keys(headers)
  .filter(name => HEADER_PASSTHRU_LIST.includes(name))
  .forEach(name => http.setHeader(name, headers[name]));

const _configureHttp = (http, headers, retry) => {
  _headerPassthru(http, headers);
  http.defaults.retry = retry;
  return http;
};

// Service Discovery API Client
export const getServiceDiscoveryApiClient = headers => _configureHttp(createServiceDiscoveryClient({
  serviceName: get(getConfig(), 'server.api.serviceName')
})({
  endpointPrefix: get(getConfig(), 'server.api.prefix'),
  retryFor: [500,502,503,504,599]
}), headers, MAX_HTTP_RETRY);

// Direct API Client
export const getDirectApiClient = headers => _configureHttp(createHttp({
  baseURL: get(getConfig(), 'server.api.endpoint'),
  endpointPrefix: get(getConfig(), 'server.api.prefix')
}), headers, 2);

export const shouldUseDiscoveryService = () => process.env.SERVICE_DISCOVERY_NAMESPACE ? true : false;

export const getApiClient = (headers) => shouldUseDiscoveryService()
  ? getServiceDiscoveryApiClient(headers)
  : getDirectApiClient(headers);

export const getReactClient = headers => _configureHttp(createHttp({
  baseURL: get(getConfig(), 'client.apiGateway.endpoint'),
  endpointPrefix: get(getConfig(), 'client.apiGateway.prefix'),
  retryFor: [500,502,503,504,599]
}), headers, MAX_HTTP_RETRY);

export const getHttpClient = headers => utils.isServer() ? getApiClient(headers) : getReactClient(headers);
